// src/components/LogoutConfirmationModal.js

import React from 'react';
import './LogoutConfirmationModal.css';

const LogoutConfirmationModal = ({ onClose, onConfirm }) => {
  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>Confirm Logout</h2>
        <p>Are you sure you want to log out?</p>
        <div className="modal-buttons">
          <button className="confirm-button" onClick={onConfirm}>
            Yes, Logout
          </button>
          <button className="button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;
